import React, { useState } from 'react';

/*
 * Migrate users from id.ruby.com to B2C
 */

import RubyLogoNavy from '../images/ruby-logo-navy.svg';
import '../fonts/Sofia.ttf';
import '../fonts/Sofia-bold.ttf';
import './MigrationLogin.css';
import * as Api from '../PortalApi';


function MigrationLogin(props) {
  const migrateUrl = window.location.origin + "/portalApi/api/authenticate/migrate";
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [verifyPassword, setVerifyPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [alert, setAlert] = useState({ show: false });
  const valid = username.length > 0 && password.length > 0;
  const [changePassword, setChangePassword] = useState(false);
  const [migrationComplete, setMigrationComplete] = useState(false);

  const charactersValid = newPassword.length >= 8 && newPassword.length <= 16;
  const hasUpper = /[A-Z]/.test(newPassword);
  const hasLower = /[a-z]/.test(newPassword);
  const hasNumber = /[0-9]/.test(newPassword);
  const verifyMatch = newPassword.length > 0 && verifyPassword === newPassword;
  const changePasswordValid = charactersValid && hasUpper && hasLower && hasNumber && verifyMatch;

  async function submitLogin(event) {
    event.preventDefault();
    setBusy(true);
    setAlert({ show: false, text: '' });
    let form = Api.makeForm({ username, password });
    if (changePassword) {
      form = Api.makeForm({ username, password, newPassword });
    }
    try {
      let response = await fetch(migrateUrl,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          },
          method: 'POST',
          body: form
        });
      let responseData = await response.json();
      if (responseData.activeUser) {
        document.cookie = 'portalUserSessionKey=' + responseData.sessionKey + ';path=/;max-age=3600';
        document.cookie = 'portalUserIdentityKey=' + responseData.identityKey + ';path=/;max-age=3600';
        setMigrationComplete(true);
        
      }
      if (responseData.invalidPassword || responseData.loginNotFound) {
        setAlert({ show: true, text: 'The username or password is incorrect.' });
      }
      if (responseData.passwordComplexityFailed) {
        setChangePassword(true);
      }
      if (responseData.error) {
        setAlert({ show: true, text: responseData.error });
      }
    } catch (e) {
      setAlert({ show: true, text: e.message });
    }
    setBusy(false);
  }

  if (migrationComplete) {
    return (
      <React.Fragment>
        <div className="container">
          <div className="topSection">
            <div className="logo">
              <img alt="Ruby Logo" src={RubyLogoNavy} />
            </div>

            <div className="form">
              <form onSubmit={submitLogin}>
                <div>
                  <div className="alert"
                    style={{ display: alert.show ? 'block' : 'none' }}>
                    {alert.text}
                  </div>
                  <div className="title">
                    Login migration complete! Here are your next steps.
                  </div>
                  <div className="details">
                    Since we’ve upgraded, the old versions of the Ruby
                    apps and online portal are no longer
                    supported. Please use the buttons below for the
                    latest versions: 
                  </div>
                  <div>
                    <button
                      onClick={() => window.location.href = "https://apps.apple.com/us/app/ruby-2-0-virtual-receptionists/id6446366312"}>
                      Download iOS App
                    </button>
                    <button
                      onClick={() => window.location.href = "https://play.google.com/store/apps/details?id=com.callruby.portal"}>
                      Download Android App
                    </button>
                    <button
                      onClick={() => window.location.href = window.location.origin}>
                      Web Portal
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="footerSection">
            <p className="contact">
              Questions? Contact us at <a href="tel:(866) 611-7829">866-611-7829</a> or <a href="mailto:staff@ruby.com">staff@ruby.com</a> </p>
          </div>
        </div>
      </React.Fragment>);
  } else {
    if (!changePassword) {
      return (
        <React.Fragment>
          <div className="container">
            <div className="topSection">
              <div className="logo">
                <img alt="Ruby Logo" src={RubyLogoNavy} />
              </div>

              <div className="form">
                <form onSubmit={submitLogin}>
                  <div>
                    <div className="alert"
                      style={{ display: alert.show ? 'block' : 'none' }}>
                      {alert.text}
                    </div>
                    <div className="title">
                      Log in
                    </div>
                    <div>
                      <div>
                        <span className="accent">*</span>
                        <label>Email or username</label>
                      </div>
                      <input type="text"
                        value={username}
                        onChange={(event) => setUsername(event.target.value)}
                        name="Username" />
                    </div>
                    <div>
                      <span className="accent">*</span>
                      <label>Password</label>
                    </div>
                    <input type="password"
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                      name="Password" />
                    {/* <div>
                      <span style={{fontWeight: 'bold', textDecoration: 'underline', fontSize: 15, cursor: 'pointer'}} onClick={() => {
                        document.cookie = "portalUserPasswordReset=reset";
                        window.location.href = window.location.origin
                      }}>Forgot your password?</span>
                    </div> */}
                    <div>
                      <button
                        onClick={submitLogin}
                        disabled={!valid || busy}>Log In</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="footerSection">
              <p className="contact">
                Questions? Contact us at <a href="tel:(866) 611-7829">866-611-7829</a> or <a href="mailto:staff@ruby.com">staff@ruby.com</a> </p>
            </div>
          </div>
        </React.Fragment>);
    } else {
      return (
        <React.Fragment>
          <div className="container">
            <div className="topSection">
              <div className="logo">
                <img alt="Ruby Logo" src={RubyLogoNavy} />
              </div>
              <div className="form">
                <form onSubmit={submitLogin}>
                  <div>
                    <div className="alert"
                      style={{ display: alert.show ? 'block' : 'none' }}>
                      {alert.text}
                    </div>
                    <div className="title">
                      Change Password
                    </div>
                    <div>
                      <ul>
                        <li>
                          8-16 characters
                          <span className="check" style={{ display: charactersValid ? 'inline' : 'none' }}>&nbsp;&#10003;</span>
                        </li>
                        <li>
                          At least one upper case
                          <span className="check" style={{ display: hasUpper ? 'inline' : 'none' }}>&nbsp;&#10003;</span>
                        </li>
                        <li>
                          At least one lower case
                          <span className="check" style={{ display: hasLower ? 'inline' : 'none' }}>&nbsp;&#10003;</span>
                        </li>
                        <li>
                          At least one number
                          <span className="check" style={{ display: hasNumber ? 'inline' : 'none' }}>&nbsp;&#10003;</span>
                        </li>
                        <li>
                          Verify password matches
                          <span className="check" style={{ display: verifyMatch ? 'inline' : 'none' }}>&nbsp;&#10003;</span>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <div>
                        <label>New Password</label>
                      </div>
                      <input type="password"
                        value={newPassword}
                        onChange={(event) => setNewPassword(event.target.value)}
                        name="Password" />
                    </div>
                    <div>
                      <label>Verify New Password</label>
                    </div>
                    <input type="password"
                      value={verifyPassword}
                      onChange={(event) => setVerifyPassword(event.target.value)}
                      name="verifyPassword" />
                    <div>
                      <button
                        onClick={submitLogin}
                        disabled={!changePasswordValid || busy}>Change Password</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="footerSection">
              <p className="contact">
                Questions? Contact us at <a href="tel:(866) 611-7829">866-611-7829</a> or <a href="mailto:staff@ruby.com">staff@ruby.com</a> </p>
            </div>

          </div>
        </React.Fragment>);
    }
  }
}

export default MigrationLogin;
